export function callbackInterval(intervalMs, callback) {
    let lastTime = 0;

    const intervalFunc = (currentTime) => {
        let stopTimer = false;
        if (currentTime >= lastTime + intervalMs) {
            lastTime += intervalMs;
            stopTimer = callback(currentTime);
        }
        if (!stopTimer) {
            window.requestAnimationFrame(intervalFunc);
        }
    };

    intervalFunc();
}
